module.exports = __webpack_public_path__ + "img/ETH-logo.981f91ba.svg";